import * as React from "react";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { Table } from "../../../../../../Shared/Table/Table";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader } from "../../../NewBusinessWizard/Components/SharedComponents";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { DocumentsAndDeclarationContent as Content } from "../../Resource/Contents";
import { DocumentTaskRequestTypeEnum } from "../../../../../../../Wrap/Constants/Enums/Tasks/DocumentTaskRequestTypeEnum";
import { DownloadButton } from "../../../../../../Shared/DownloadButton/DownloadButton";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { DocumentsHelper } from "../../../PortfolioDashboard/Components/Document/Resource/DocumentsHelper";
import { processTypeEnum } from "../../../Common/Resource/Contents";

interface IDocumentsAndDeclarationsProps extends IProcessComponentProps {
    data: any;
    customerId: number;
}

interface IDocumentsAndDeclarationsState {
    checkedDeclarations: number[];
    isClientDeclarationUploaded: boolean;
}

export class DocumentsAndDeclarations extends ProcessComponent<
    IDocumentsAndDeclarationsProps,
    IDocumentsAndDeclarationsState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            isClientDeclarationUploaded: false,
            checkedDeclarations: [],
        };
    }

    componentDidMount() {
        if (this.props.isReview) {
            this.setState({ checkedDeclarations: [1, 2, 3, 4] });
        }
    }

    isValid() {
        if (this.state.checkedDeclarations.length < 4) {
            this.props.showErrorMsgPopUp([Content.validation.mustAcceptAll], true);
        }
        // if (!this.state.isClientDeclarationUploaded){
        //     this.props.showErrorMsgPopUp([Content.validation.uploadDeclaration], true);
        // }
        return super.isValid() && this.state.checkedDeclarations.length == 4; //&& this.state.isClientDeclarationUploaded;
    }

    render() {
        return (
            <>
                <h2>{Content.header}</h2>
                {this.renderClientDeclaration()}
                <hr className="mb-17" />

                {this.renderDocumentsToPost()}
                <hr className="mb-17" />

                {this.renderDocumentsAvailable()}
                <hr className="mb-17" />

                {this.renderDeclarations()}
                <hr className="mb-17" />
            </>
        );
    }

    private renderClientDeclaration() {
        const { data } = this.props;
        return (
            <>
                {SectionHeader(Content.clientDeclaration.header)}
                <p>{Content.clientDeclaration.label}</p>
                <div className="row">
                    <div className="col-11">
                        <b style={{ color: "#147cb3" }}>
                            {Content.clientDeclaration.uploadLabel(
                                data?.ClientDetails?.FirstName,
                                data?.ClientDetails?.LastName
                            )}
                        </b>
                    </div>
                    <div className="col-1">
                        <div className="row">
                            <div className="col-8">
                                <a className="download-button" target="_blank" href="">
                                    <span className="icon" aria-hidden="true"></span>
                                </a>
                            </div>
                            <div className="col-3">
                                <button className="send-email-button" onClick={() => {}}>
                                    <span className="icon" aria-hidden="true"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {!this.state.isClientDeclarationUploaded && !this.props.isReview ? (
                    <div>
                        <button
                            type="button"
                            className="upload-button mt-15"
                            onClick={() => {
                                this.setState({ isClientDeclarationUploaded: !this.state.isClientDeclarationUploaded });
                            }}
                        >
                            <span className="icon" aria-hidden="true" />
                            {Content.clientDeclaration.uploadInstruction}
                        </button>
                    </div>
                ) : (
                    <p
                        className="alert-success small"
                        onClick={() => {
                            this.setState({ isClientDeclarationUploaded: !this.state.isClientDeclarationUploaded });
                        }}
                    >
                        {Content.clientDeclaration.successfullyUploaded}
                    </p>
                )}
            </>
        );
    }

    private renderDocumentsToPost() {
        const customerid = this.props;
        const claccountid = this.props.data?.SubAccountClientDetail?.ClAccountId;
        const instructionId = getQueryParameters()["id"];
        const headAccountHierarchyId = getQueryParameters()["hierarchyid"];
        const remittanceAdviceSlipQuery = DocumentsHelper.getTaskRequest(
            instructionId,
            customerid.toString(),
            claccountid,
            headAccountHierarchyId,
            DocumentTaskRequestTypeEnum.RemittanceAdviceSlip,
            processTypeEnum.topUpWithITFLS
        );
        const transferFormQuery = DocumentsHelper.getTaskRequest(
            instructionId,
            customerid.toString(),
            claccountid,
            headAccountHierarchyId,
            DocumentTaskRequestTypeEnum.TransferForm,
            processTypeEnum.topUpWithITFLS
        );
        return (
            <>
                {SectionHeader("Documents to post")}
                <p>Please complete this form if any of the parties are not Origo members</p>
                <div className="mb-24">
                    <a className="hyperlink">Transfer in or re-registration form (non-Origo)</a>
                    <DownloadButton
                        request={transferFormQuery}
                        selectedAccount={headAccountHierarchyId}
                    ></DownloadButton>
                </div>
                <p>For the cheque payment, your client needs to write {claccountid} on the back of their cheque</p>
                <div className="mb-24">
                    <a className="hyperlink">Remittance Advice slip</a>
                    <DownloadButton
                        request={remittanceAdviceSlipQuery}
                        selectedAccount={headAccountHierarchyId}
                    ></DownloadButton>
                </div>
                <p>Send the completed forms to: </p>
                <p>(display clients correspondence address)</p>
                <hr className="mb-17" />
            </>
        );
    }

    private renderDocumentsAvailable() {
        return (
            <>
                {SectionHeader(Content.documentsAvailable.header)}
                <p>{Content.documentsAvailable.label}</p>
                <div className="row">
                    <div className="col-11">
                        <Accordion label="SIPP Documents" cssWrapper="accordion-simple" iconCss="icon-Group-6">
                            <Table
                                data={[{ FileName: "Transfer in" }, { FileName: "Remittance Advice Slip" }]}
                                col={[
                                    {
                                        title: "File name",
                                        key: "FileName",
                                        render: (data) => {
                                            return (
                                                <div className="row">
                                                    <div className="col-10">
                                                        <a className="hyperlink">{data}</a>
                                                    </div>
                                                    <div className="col-1">
                                                        <a className="download-button" target="_blank" href="">
                                                            <span className="icon" aria-hidden="true"></span>
                                                        </a>
                                                    </div>
                                                    <div className="col-1">
                                                        <button className="send-email-button" onClick={() => {}}>
                                                            <span className="icon" aria-hidden="true"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            );
                                        },
                                    },
                                ]}
                            />
                        </Accordion>
                    </div>
                    <div className="col-1">
                        <div className="row">
                            <div className="col-6">
                                <a className="archive-file-button" target="_blank" href="">
                                    <span className="icon" aria-hidden="true"></span>
                                </a>
                            </div>
                            <div className="col-6">
                                <button className="send-email-button" onClick={() => {}}>
                                    <span className="icon" aria-hidden="true"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    private renderDeclarations() {
        return (
            <>
                <h2 className="mb-22">{Content.declarations.header}</h2>
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: Content.declarations.authorityToProceed,
                            disabled: this.props.isReview,
                            value: this.state.checkedDeclarations.includes(1),
                            onChange: (v) => {
                                const checked = this.state.checkedDeclarations;
                                if (v) {
                                    this.setState({ checkedDeclarations: checked.concat(1) });
                                } else {
                                    this.setState({ checkedDeclarations: checked.filter((ele) => ele != 1) });
                                }
                            },
                        },
                    ]}
                />
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: Content.declarations.checkedAddress,
                            disabled: this.props.isReview,
                            value: this.state.checkedDeclarations.includes(2),
                            onChange: (v) => {
                                const checked = this.state.checkedDeclarations;
                                if (v) {
                                    this.setState({ checkedDeclarations: checked.concat(2) });
                                } else {
                                    this.setState({ checkedDeclarations: checked.filter((ele) => ele != 2) });
                                }
                            },
                        },
                    ]}
                />
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: Content.declarations.confirmList,
                            value: this.state.checkedDeclarations.includes(3),
                            disabled: this.props.isReview,
                            onChange: (v) => {
                                const checked = this.state.checkedDeclarations;
                                if (v) {
                                    this.setState({ checkedDeclarations: checked.concat(3) });
                                } else {
                                    this.setState({ checkedDeclarations: checked.filter((ele) => ele != 3) });
                                }
                            },
                        },
                    ]}
                />
                <ol className="ml-15">
                    <li className="mb-15">{Content.declarations.firstConfirm}</li>
                    <li className="mb-15">{Content.declarations.secondConfirm}</li>
                    <li className="mb-15">{Content.declarations.thirdConfirm}</li>
                    <li className="mb-15">{Content.declarations.fourConfirm}</li>
                </ol>
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: Content.declarations.explainedDataProtection,
                            value: this.state.checkedDeclarations.includes(4),
                            disabled: this.props.isReview,
                            onChange: (v) => {
                                const checked = this.state.checkedDeclarations;
                                if (v) {
                                    this.setState({ checkedDeclarations: checked.concat(4) });
                                } else {
                                    this.setState({ checkedDeclarations: checked.filter((ele) => ele != 4) });
                                }
                            },
                        },
                    ]}
                />
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: Content.declarations.confirmAll,
                            disabled: this.props.isReview,
                            value: this.state.checkedDeclarations.length == 4,
                            onChange: (v) => {
                                if (v) {
                                    this.setState({ checkedDeclarations: [1, 2, 3, 4] });
                                } else {
                                    this.setState({ checkedDeclarations: [] });
                                }
                            },
                        },
                    ]}
                />
            </>
        );
    }
}
